import React, { useState, useEffect} from "react";
import { fetchUserAttributes } from "aws-amplify/auth";
const NAV_HEIGHT = 70;
const PANEL_W = 1170;
const PANEL_H = 837;
const PANEL_PAD = 24;
const PANEL_RADIUS = 32;

function Field({ label, type = "text", placeholder, width = "311px" }) {
  const [active, setActive] = useState(false);
  return (
    <div
      style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}
    >
      <label
        style={{
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontSize: 14,
          fontWeight: 500,
        }}
      >
        {label}
      </label>
      <input
        className="mk-input"
        type={type}
        placeholder={placeholder}
        onFocus={() => setActive(true)}
        onBlur={() => setActive(false)}
        style={{
          width: width,
          height: 48,
          borderRadius: 16,
          padding: "16px",
          border: "1px solid rgba(255,255,255,0.22)",
          background: "rgba(255,255,255,0.15)",
          backdropFilter: active ? "blur(30px)" : "none",
          WebkitBackdropFilter: active ? "blur(30px)" : "none",
          color: "#fff",
          fontFamily: "Manrope",
          fontSize: "15px",
          outline: "none",
          transition: "all .2s ease",
          minWidth: 0,
        }}
      />
    </div>
  );
}

function LinkedStudents() {
  const [hoveredStudent, setHoveredStudent] = useState(null);

  const students = [
    { id: 0, name: "Aunt Jean", image: "/Aunt_Jean.png" },
    { id: 1, name: "Cousin Sophie", image: "/Cousin_Sophie.png" },
    { id: 2, name: "Dad Fred", image: "/Dad_Fred.png" },
    { id: 3, name: "Grandma Sara", image: "/Grandma_Sara.png" },
    { id: 4, name: "Uncle Johnny", image: "/Uncle_Johnny.png" },
    { id: 5, name: "", image: "/addicon.svg" },
  ];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
      <label
        style={{
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontSize: 14,
          fontWeight: 500,
        }}
      >
        Friends & Family
      </label>
      <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
        {students.map((student) => (
          <div
            key={student.id}
            onMouseEnter={() => setHoveredStudent(student.id)}
            onMouseLeave={() => setHoveredStudent(null)}
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 8,
              cursor: "pointer",
            }}
          >
            <div
              style={{
                width: 60,
                height: 60,
                borderRadius: "50%",
                padding: 4,

                transition: "background .2s ease",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={student.image}
                alt={student.name}
                style={{
                  width: 52,
                  height: 52,
                  borderRadius: "50%",
                  objectFit: "cover",
                  objectPosition: "center",
                  imageRendering: "auto",
                  display: "block",
                }}
              />
            </div>
            <span
              style={{
                color: "#fff",
                fontFamily: "Manrope",
                fontSize: 12,
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              {student.name}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

function AddStudentButton() {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        marginBottom: 24,
      }}
    >
      <label
        style={{
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontSize: 14,
          fontWeight: 500,
        }}
      >
        Add student
      </label>
      <div
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 8,
          cursor: "pointer",
          width: "fit-content",
        }}
      >
        <div
          style={{
            width: 60,
            height: 60,
            borderRadius: "50%",
            background: isHovered
              ? "rgba(255,255,255,0.2)"
              : "rgba(255,255,255,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "background .2s ease",
          }}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 5V19M5 12H19"
              stroke="white"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
          </svg>
        </div>
        <span
          style={{
            color: "#fff",
            fontFamily: "Manrope",
            fontSize: 12,
            fontWeight: 500,
          }}
        >
          Add student
        </span>
      </div>
    </div>
  );
}

const ParentProfile = ({ givenName }) => {
  const [paymentMethod, setPaymentMethod] = useState("Credit card");
  const [dropdownOpen, setDropdownOpen] = useState(false);
 
  const paymentOptions = [
    "Credit card",
    "Debit card",
    "PayPal",
    "Bank transfer",
  ];
  const parentstyles = {
    card: {
      borderRadius: '8px',
      maxWidth: '384px',
      fontFamily: "Manrope",
      letterSpacing:'1px',
    },
    imageContainer: {
      display:'flex',
      marginBottom: '16px',
    },
    profileImage: {
      width: '192px',
      height: '192px',
      objectFit: 'cover',
      borderRadius: '4px'
    },
    editButton: {
     
      color: '#fff',
      fontSize: '14px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '4px 8px'
    },
    nameSection: {
      marginBottom: '16px'
    },
    nameRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '8px'
    },
    name: {
      color: 'white',
      fontSize: '24px',
      fontWeight: '600',
      margin: '0'
    },
    contactInfo: {
      color: 'white'
    },
    infoText: {
      fontSize: '14px',
      margin: '4px 0',
      color: 'white'
    }
  };
 
  return (
    <>
      <div
        style={{
          display: "flex",
          width: "320px",
          padding: "16px",
          alignItems: "flex-start",
          gap: "8px",
          borderRadius: "16px",
          border: "1px solid var(--Grey-grey-100, #EBEBEB)",
          background: "rgba(255, 255, 255, 0.20)",
          marginTop: 40,
          gap: 16,
        }}
      >
        <div style={{}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              d="M17.1287 27.525C17.1364 27.3419 17.4397 27.2692 17.5297 27.4289C17.9519 28.1784 18.6721 29.2806 19.4894 29.7818C20.3066 30.283 21.6156 30.4252 22.4751 30.4617C22.6582 30.4694 22.7309 30.7727 22.5712 30.8627C21.8217 31.2849 20.7195 32.0051 20.2183 32.8224C19.7171 33.6396 19.5749 34.9486 19.5384 35.8081C19.5306 35.9912 19.2274 36.0639 19.1374 35.9042C18.7152 35.1547 17.995 34.0525 17.1777 33.5513C16.3605 33.0501 15.0514 32.9079 14.192 32.8714C14.0089 32.8637 13.9362 32.5604 14.0959 32.4704C14.8454 32.0482 15.9476 31.328 16.4488 30.5107C16.95 29.6935 17.0922 28.3845 17.1287 27.525Z"
              fill="white"
            />
            <path
              opacity="0.5"
              d="M30.8185 25.8584C30.8044 25.6757 30.4846 25.5991 30.3892 25.7555C30.1021 26.2264 29.6879 26.7946 29.2276 27.0769C28.7674 27.3592 28.0731 27.4706 27.5232 27.5131C27.3405 27.5272 27.2639 27.847 27.4203 27.9424C27.8912 28.2295 28.4594 28.6437 28.7417 29.1039C29.024 29.5642 29.1354 30.2585 29.1779 30.8084C29.192 30.9911 29.5117 31.0677 29.6072 30.9113C29.8943 30.4404 30.3084 29.8722 30.7687 29.5899C31.229 29.3076 31.9233 29.1962 32.4732 29.1537C32.6559 29.1396 32.7325 28.8198 32.5761 28.7244C32.1052 28.4373 31.537 28.0231 31.2547 27.5628C30.9724 27.1026 30.861 26.4083 30.8185 25.8584Z"
              fill="white"
            />
            <path
              d="M24.5044 6.6696L24.1005 6.15948C22.5395 4.18769 21.7589 3.20179 20.8509 3.34733C19.9428 3.49287 19.5086 4.67346 18.6402 7.03464L18.4155 7.6455C18.1687 8.31647 18.0453 8.65196 17.8087 8.8982C17.5721 9.14443 17.2489 9.27354 16.6027 9.53177L16.0144 9.76686L15.6013 9.93214C13.6021 10.7342 12.5947 11.1888 12.4661 12.072C12.3289 13.0141 13.2824 13.82 15.1894 15.4318L15.6828 15.8488C16.2247 16.3069 16.4957 16.5359 16.651 16.848C16.8063 17.1602 16.8284 17.5202 16.8726 18.2401L16.9129 18.8955C17.0685 21.4289 17.1464 22.6956 17.9696 23.1323C18.7929 23.569 19.8164 22.8865 21.8634 21.5215L21.8634 21.5215L22.393 21.1683C22.9747 20.7804 23.2655 20.5865 23.5982 20.5332C23.9308 20.4799 24.2676 20.5732 24.9412 20.7599L25.5544 20.9299C27.9246 21.5869 29.1097 21.9155 29.7557 21.2433C30.4017 20.5711 30.0808 19.3433 29.4389 16.8879L29.2729 16.2526C29.0905 15.5549 28.9992 15.206 29.0495 14.8609C29.0998 14.5158 29.2858 14.2135 29.6578 13.609L29.6578 13.609L29.9966 13.0586C31.3058 10.9313 31.9605 9.86764 31.5364 9.01549C31.1124 8.16335 29.8906 8.08708 27.4469 7.93453L26.8146 7.89506C26.1202 7.85171 25.773 7.83003 25.4714 7.67006C25.1698 7.51009 24.948 7.22993 24.5044 6.66961L24.5044 6.6696Z"
              fill="white"
            />
            <path
              opacity="0.5"
              d="M14.7224 22.2105C11.1603 23.9508 8.19625 26.7071 7.07812 30.0007C5.82387 22.1548 7.56366 17.0882 10.3525 13.9392C10.5929 14.4304 10.9052 14.8371 11.1857 15.1549C11.7688 15.8156 12.606 16.5229 13.4561 17.241L14.0678 17.758C14.1838 17.856 14.274 17.9323 14.3507 17.9985C14.3585 18.1057 14.3662 18.2309 14.3762 18.3932L14.4259 19.2023C14.4927 20.294 14.5579 21.3596 14.7224 22.2105Z"
              fill="white"
            />
          </svg>
        </div>
        <div>
          <p style={{ color: "#FFF", fontSize: "18px", fontFamily: "Manrope" }}>
            Hello Susan,
          </p>
          <p style={{ color: "#FFF", fontSize: "15px", fontFamily: "Manrope" }}>
            I'm learning from our chats. Click here for auto fill.
          </p>
        </div>
      </div>
 
      {/* <div
        style={{ display: "flex", alignItems: "center", gap: 16, marginTop: 0 }}
      >
        <img
          src="/parent.png"
          alt="profile"
          style={{
            width: 64,
            height: 64,
            // borderRadius: "50%",
            objectFit: "cover",
            objectPosition: "center",
            imageRendering: "auto",
            display: "block",
          }}
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <span
            style={{
              color: "#fff",
              fontSize: 14,
              fontFamily: "Manrope",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Add picture
          </span>
          <span
            style={{
              color: "#DB3235",
              fontSize: 12,
              fontFamily: "Manrope",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Remove
          </span>
        </div>
      </div> */}
      {/* -----------------------------------------------------------new content here----------------------------------------------------------- */}
     
      <div style={parentstyles.card}>
      {/* Profile Picture Section */}
      <div style={parentstyles.imageContainer}>
      <img
          src="/parent.png"
          alt="profile"
          style={parentstyles.profileImage}
        />
       <div style={{display:'flex',flexDirection:'column', justifyContent:'flex-end'}}>
       <p style={parentstyles.editButton}>
          Edit picture
        </p>
        <p style={{color:'red',
      fontSize: '14px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '0px 8px'
        }}>
          remove
        </p>
        
       </div>
       
      </div>
 
      {/* Name Section */}
      <div style={parentstyles.nameSection}>
        <div style={parentstyles.nameRow}>
          <h2 style={parentstyles.name}>Susan Park</h2>
          <p style={parentstyles.editButton}>
            Edit main info
          </p>
        </div>
      </div>
 
      {/* Contact Information */}
      <div style={parentstyles.contactInfo}>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>susanpark@gmail.com</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>310-595-4832</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>2384 Bedford Way</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Seattle, WA 98040</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Birthday: 06/17/1973</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Preferred Contact: call</p>
 
        <h2 style={{
          color: 'white',
          fontSize: '18px',
          fontWeight: '700',
          margin: '0',
          marginTop:'24px'
        }}> Family Values</h2>
      </div>
    </div>
 
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 16,
          minWidth: 0,
          fontFamily: "Manrope",
        }}
      >
        <Field label="Favorite Family Holiday" placeholder="" />
        <Field label="Best Vacation Spot" placeholder="" />
        <Field label="We Root For(sports team)" placeholder="" />
        <Field label="My Alma Matter" placeholder="" />

      </div>
 
      
    </>
  );
}
 

/** Student Profile Content */
const StudentProfile = ({ givenName }) => { 
  const studentstyles = {
    card: {
      borderRadius: '8px',
      maxWidth: '384px',
      fontFamily: "Manrope",
      letterSpacing: "1px",
 
    },
    imageContainer: {
      display:'flex',
      marginBottom: '16px',
    },
    profileImage: {
      width: '192px',
      height: '192px',
      objectFit: 'cover',
      borderRadius: '4px'
    },
    editButton: {
     
      color: '#fff',
      fontSize: '14px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '4px 8px'
    },
    nameSection: {
      marginBottom: '16px'
    },
    nameRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '8px'
    },
    name: {
      color: 'white',
      fontSize: '24px',
      fontWeight: '600',
      margin: '0'
    },
    contactInfo: {
      color: 'white'
    },
    infoText: {
      fontSize: '14px',
      margin: '4px 0',
      color: 'white'
    }
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          width: "320px",
          padding: "16px",
          alignItems: "flex-start",
          gap: "8px",
          borderRadius: "16px",
          border: "1px solid var(--Grey-grey-100, #EBEBEB)",
          background: "rgba(255, 255, 255, 0.20)",
          marginTop: 40,
          gap: 16,
        }}
      >
        <div style={{}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              d="M17.1287 27.525C17.1364 27.3419 17.4397 27.2692 17.5297 27.4289C17.9519 28.1784 18.6721 29.2806 19.4894 29.7818C20.3066 30.283 21.6156 30.4252 22.4751 30.4617C22.6582 30.4694 22.7309 30.7727 22.5712 30.8627C21.8217 31.2849 20.7195 32.0051 20.2183 32.8224C19.7171 33.6396 19.5749 34.9486 19.5384 35.8081C19.5306 35.9912 19.2274 36.0639 19.1374 35.9042C18.7152 35.1547 17.995 34.0525 17.1777 33.5513C16.3605 33.0501 15.0514 32.9079 14.192 32.8714C14.0089 32.8637 13.9362 32.5604 14.0959 32.4704C14.8454 32.0482 15.9476 31.328 16.4488 30.5107C16.95 29.6935 17.0922 28.3845 17.1287 27.525Z"
              fill="white"
            />
            <path
              opacity="0.5"
              d="M30.8185 25.8584C30.8044 25.6757 30.4846 25.5991 30.3892 25.7555C30.1021 26.2264 29.6879 26.7946 29.2276 27.0769C28.7674 27.3592 28.0731 27.4706 27.5232 27.5131C27.3405 27.5272 27.2639 27.847 27.4203 27.9424C27.8912 28.2295 28.4594 28.6437 28.7417 29.1039C29.024 29.5642 29.1354 30.2585 29.1779 30.8084C29.192 30.9911 29.5117 31.0677 29.6072 30.9113C29.8943 30.4404 30.3084 29.8722 30.7687 29.5899C31.229 29.3076 31.9233 29.1962 32.4732 29.1537C32.6559 29.1396 32.7325 28.8198 32.5761 28.7244C32.1052 28.4373 31.537 28.0231 31.2547 27.5628C30.9724 27.1026 30.861 26.4083 30.8185 25.8584Z"
              fill="white"
            />
            <path
              d="M24.5044 6.6696L24.1005 6.15948C22.5395 4.18769 21.7589 3.20179 20.8509 3.34733C19.9428 3.49287 19.5086 4.67346 18.6402 7.03464L18.4155 7.6455C18.1687 8.31647 18.0453 8.65196 17.8087 8.8982C17.5721 9.14443 17.2489 9.27354 16.6027 9.53177L16.0144 9.76686L15.6013 9.93214C13.6021 10.7342 12.5947 11.1888 12.4661 12.072C12.3289 13.0141 13.2824 13.82 15.1894 15.4318L15.6828 15.8488C16.2247 16.3069 16.4957 16.5359 16.651 16.848C16.8063 17.1602 16.8284 17.5202 16.8726 18.2401L16.9129 18.8955C17.0685 21.4289 17.1464 22.6956 17.9696 23.1323C18.7929 23.569 19.8164 22.8865 21.8634 21.5215L21.8634 21.5215L22.393 21.1683C22.9747 20.7804 23.2655 20.5865 23.5982 20.5332C23.9308 20.4799 24.2676 20.5732 24.9412 20.7599L25.5544 20.9299C27.9246 21.5869 29.1097 21.9155 29.7557 21.2433C30.4017 20.5711 30.0808 19.3433 29.4389 16.8879L29.2729 16.2526C29.0905 15.5549 28.9992 15.206 29.0495 14.8609C29.0998 14.5158 29.2858 14.2135 29.6578 13.609L29.6578 13.609L29.9966 13.0586C31.3058 10.9313 31.9605 9.86764 31.5364 9.01549C31.1124 8.16335 29.8906 8.08708 27.4469 7.93453L26.8146 7.89506C26.1202 7.85171 25.773 7.83003 25.4714 7.67006C25.1698 7.51009 24.948 7.22993 24.5044 6.66961L24.5044 6.6696Z"
              fill="white"
            />
            <path
              opacity="0.5"
              d="M14.7224 22.2105C11.1603 23.9508 8.19625 26.7071 7.07812 30.0007C5.82387 22.1548 7.56366 17.0882 10.3525 13.9392C10.5929 14.4304 10.9052 14.8371 11.1857 15.1549C11.7688 15.8156 12.606 16.5229 13.4561 17.241L14.0678 17.758C14.1838 17.856 14.274 17.9323 14.3507 17.9985C14.3585 18.1057 14.3662 18.2309 14.3762 18.3932L14.4259 19.2023C14.4927 20.294 14.5579 21.3596 14.7224 22.2105Z"
              fill="white"
            />
          </svg>
        </div>
        <div>
          <p style={{ color: "#FFF", fontSize: "18px", fontFamily: "Manrope" }}>
            Hello Maggie,
          </p>
          <p style={{ color: "#FFF", fontSize: "15px", fontFamily: "Manrope" }}>
            I'm learning from our chats. Click here for auto fill.
          </p>
        </div>
      </div>
      
      <div style={studentstyles.card}>
      {/* Profile Picture Section */}
      <div style={studentstyles.imageContainer}>
      <img
          src="/student.png"
          alt="profile"
          style={studentstyles.profileImage}
        />
       <div style={{display:'flex',flexDirection:'column', justifyContent:'flex-end', marginLeft: '12px'}}>
        <p style={studentstyles.editButton}>
          Edit picture
        </p>
        <p style={{color:'red',
          fontSize: '14px',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          padding: '0px 8px'
          }}>
            remove
        </p>
        <button
            style={{
              height: "36px",
              borderRadius: "18px",
              padding: "0 12px",
              border: "1px solid rgba(255,255,255,0.8)",
              background: "transparent",
              color: "#fff",
              fontFamily: "Manrope",
              fontSize: "14px",
              fontWeight: "500",
              outline: "none",
              cursor: "pointer",
              transition: "all .2s ease",
              marginTop: "8px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
            }}
            onClick={() => {
              // Add contact action here
              // console.log("Contact button clicked");
            }}
          > 
            + Add Student
          </button>
       </div>
      </div>
 
      {/* Name Section */}
      <div style={studentstyles.nameSection}>
        <div style={studentstyles.nameRow}>
          <h2 style={studentstyles.name}>Maggie Park</h2>
          <p style={studentstyles.editButton}>
            Edit main info
          </p>
        </div>
      </div>
 
      {/* Contact Information */}
      <div style={studentstyles.infoSection}>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Junior • UCLA</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Born 10/12/2005</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Gender: Female</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Graduates in 2027</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Psychology Major</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Residence: Hedrick Hall</p>
      </div>
 
      <div style={studentstyles.nameSection}>
        <div style={studentstyles.nameRow}>
          <h2 style={{
      color: 'white',
      fontSize: '18px',
      fontWeight: '700',
      margin: '0',
      marginTop:'24px'
    }}> Characteristics</h2>
          <p style={{
              color: '#fff',
      fontSize: '14px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '4px 8px',
      marginTop:'24px'
          }}>
            Edit main info
          </p>
        </div>
      </div>
 
      <div style={studentstyles.infoSection}>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Allergies: Peanuts</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Comfort Food: Sushi, Potato Chips, Lava Cake</p>
        <p style={{
          fontSize: "14px",
          margin: "4px 0",
          color: "rgba(255,255,255,0.85)",
          fontFamily: "Manrope",
          fontWeight: 500,
          letterSpacing: "0.2px"
        }}>Favorite Novel: Love in the Time of Cholera</p>
       
      </div>
 
      <h2 style={{
      color: 'white',
      fontSize: '18px',
      fontWeight: '700',
      margin: '0',
      marginTop:'24px'
    }}> Tell Us More</h2>
    </div>
 
 {/* -----------------------------------------------------------new content here----------------------------------------------------------- */}
      {/* Fields with University row */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 16,
          minWidth: 0,
        }}
      >
        {/* University and Year row */}
        <Field label="Hobbies" placeholder="" />
        <Field label="Coffe Order" placeholder="" />
        <Field label="Favourite Movie" placeholder="" />
        <Field label="Early Bird or Night Owl?" placeholder="" />
 
 
        {/* <Field label="Full Name" placeholder="John Snow" />
        <div style={{ display: "flex", gap: 16, alignItems: "end" }}>
          <Field
            label="University / School Name"
            placeholder="Loyala University"
            width="171px"
          />
          <Field label="Year" placeholder="2021" width="120px" />
        </div>
 
       
        <Field label="Major/Focus Area" placeholder="Information Technologies" />
        <Field label="Birthday" placeholder="12/08/1989" />
        <Field label="Allergies" placeholder="Peanuts allergies" />
        <Field label="Dorm/Residence" placeholder="Location" />
        <Field label="Favorite Foods/Comforts" placeholder="" /> */}
      </div>
     
    </>
  );
}
 

const FriendsFamily = ({ givenName }) => {
  return (
    <>

     <div
        style={{
          display: "flex",
          width: "320px",
          padding: "16px",
          alignItems: "flex-start",
          gap: "8px",
          borderRadius: "16px",
          border: "1px solid var(--Grey-grey-100, #EBEBEB)",
          background: "rgba(255, 255, 255, 0.20)",
          marginTop: 40,
          gap: 16,
        }}
      >
        <div style={{}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              d="M17.1287 27.525C17.1364 27.3419 17.4397 27.2692 17.5297 27.4289C17.9519 28.1784 18.6721 29.2806 19.4894 29.7818C20.3066 30.283 21.6156 30.4252 22.4751 30.4617C22.6582 30.4694 22.7309 30.7727 22.5712 30.8627C21.8217 31.2849 20.7195 32.0051 20.2183 32.8224C19.7171 33.6396 19.5749 34.9486 19.5384 35.8081C19.5306 35.9912 19.2274 36.0639 19.1374 35.9042C18.7152 35.1547 17.995 34.0525 17.1777 33.5513C16.3605 33.0501 15.0514 32.9079 14.192 32.8714C14.0089 32.8637 13.9362 32.5604 14.0959 32.4704C14.8454 32.0482 15.9476 31.328 16.4488 30.5107C16.95 29.6935 17.0922 28.3845 17.1287 27.525Z"
              fill="white"
            />
            <path
              opacity="0.5"
              d="M30.8185 25.8584C30.8044 25.6757 30.4846 25.5991 30.3892 25.7555C30.1021 26.2264 29.6879 26.7946 29.2276 27.0769C28.7674 27.3592 28.0731 27.4706 27.5232 27.5131C27.3405 27.5272 27.2639 27.847 27.4203 27.9424C27.8912 28.2295 28.4594 28.6437 28.7417 29.1039C29.024 29.5642 29.1354 30.2585 29.1779 30.8084C29.192 30.9911 29.5117 31.0677 29.6072 30.9113C29.8943 30.4404 30.3084 29.8722 30.7687 29.5899C31.229 29.3076 31.9233 29.1962 32.4732 29.1537C32.6559 29.1396 32.7325 28.8198 32.5761 28.7244C32.1052 28.4373 31.537 28.0231 31.2547 27.5628C30.9724 27.1026 30.861 26.4083 30.8185 25.8584Z"
              fill="white"
            />
            <path
              d="M24.5044 6.6696L24.1005 6.15948C22.5395 4.18769 21.7589 3.20179 20.8509 3.34733C19.9428 3.49287 19.5086 4.67346 18.6402 7.03464L18.4155 7.6455C18.1687 8.31647 18.0453 8.65196 17.8087 8.8982C17.5721 9.14443 17.2489 9.27354 16.6027 9.53177L16.0144 9.76686L15.6013 9.93214C13.6021 10.7342 12.5947 11.1888 12.4661 12.072C12.3289 13.0141 13.2824 13.82 15.1894 15.4318L15.6828 15.8488C16.2247 16.3069 16.4957 16.5359 16.651 16.848C16.8063 17.1602 16.8284 17.5202 16.8726 18.2401L16.9129 18.8955C17.0685 21.4289 17.1464 22.6956 17.9696 23.1323C18.7929 23.569 19.8164 22.8865 21.8634 21.5215L21.8634 21.5215L22.393 21.1683C22.9747 20.7804 23.2655 20.5865 23.5982 20.5332C23.9308 20.4799 24.2676 20.5732 24.9412 20.7599L25.5544 20.9299C27.9246 21.5869 29.1097 21.9155 29.7557 21.2433C30.4017 20.5711 30.0808 19.3433 29.4389 16.8879L29.2729 16.2526C29.0905 15.5549 28.9992 15.206 29.0495 14.8609C29.0998 14.5158 29.2858 14.2135 29.6578 13.609L29.6578 13.609L29.9966 13.0586C31.3058 10.9313 31.9605 9.86764 31.5364 9.01549C31.1124 8.16335 29.8906 8.08708 27.4469 7.93453L26.8146 7.89506C26.1202 7.85171 25.773 7.83003 25.4714 7.67006C25.1698 7.51009 24.948 7.22993 24.5044 6.66961L24.5044 6.6696Z"
              fill="white"
            />
            <path
              opacity="0.5"
              d="M14.7224 22.2105C11.1603 23.9508 8.19625 26.7071 7.07812 30.0007C5.82387 22.1548 7.56366 17.0882 10.3525 13.9392C10.5929 14.4304 10.9052 14.8371 11.1857 15.1549C11.7688 15.8156 12.606 16.5229 13.4561 17.241L14.0678 17.758C14.1838 17.856 14.274 17.9323 14.3507 17.9985C14.3585 18.1057 14.3662 18.2309 14.3762 18.3932L14.4259 19.2023C14.4927 20.294 14.5579 21.3596 14.7224 22.2105Z"
              fill="white"
            />
          </svg>
        </div>
        <div>
          <p style={{ color: "#FFF", fontSize: "18px", fontFamily: "Manrope" }}>
            Hello {givenName}, 
          </p>
          <p style={{ color: "#FFF", fontSize: "15px", fontFamily: "Manrope" }}>
            I'm learning from our chats. Click here for auto fill.
          </p>
        </div>
      </div>

      <LinkedStudents/>

      {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 16,
          marginTop: 0,
        }}
      >
        <img
          src="/mindy-avatar.svg"
          alt="profile"
          style={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            objectFit: "cover",
            objectPosition: "center",
            imageRendering: "auto",
            display: "block",
          }}
        />
        <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
          <span
            style={{
              color: "#fff",
              fontSize: 14,
              fontFamily: "Manrope",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            edit picture
          </span>
          <span
            style={{
              color: "#DB3235",
              fontSize: 12,
              fontFamily: "Manrope",
              fontWeight: 600,
              cursor: "pointer",
            }}
          >
            Remove
          </span>
        </div>
      </div> */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr",
          gap: 16,
          minWidth: 0,
        }}
      >
        <Field label="Name" placeholder="Jean Kay" />
        <Field label="Relationship to Student" placeholder="Aunt" />
        <Field label="Birthday" placeholder="03/15/1992" />
        <Field label="Contact Info" placeholder="jean.kay27@gmail.com" />
      </div>
    </>
  );
}

function HopesGoals() {
  // const [paymentMethod, setPaymentMethod] = useState("Credit card");
  // const [dropdownOpen, setDropdownOpen] = useState(false);

  // const paymentOptions = [
  //   "Credit card",
  //   "Debit card",
  //   "PayPal",
  //   "Bank transfer",
  // ];

  return (

    <>
    <div>
      <p style={{fontSize:'15px', fontFamily:'Manrope', fontWeight:700,color:'#FFF', marginTop:'40px' }}>Add Your thought by complete this question </p>
      


      <div style={{
        height:'60px',
        width:'60px'
      }}><svg xmlns="http://www.w3.org/2000/svg" width="94" height="94" viewBox="0 0 94 94" fill="none">
  <g filter="url(#filter0_d_815_7382)">
    <rect x="17" y="17" width="60" height="60" rx="27" fill="white" fill-opacity="0.6" shape-rendering="crispEdges"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M46.6926 32.0042C47.5298 32.0044 48.2083 32.5682 48.208 33.2634L48.1987 60.1181C48.1985 60.8133 47.5196 61.3767 46.6824 61.3765C45.8452 61.3763 45.1668 60.8126 45.167 60.1174L45.1763 33.2627C45.1766 32.5675 45.8554 32.004 46.6926 32.0042ZM30.5196 43.7493C31.3568 43.7495 32.0352 44.3132 32.035 45.0085L32.0338 48.3653C32.0336 49.0605 31.3547 49.6239 30.5175 49.6237C29.6804 49.6235 29.0019 49.0598 29.0021 48.3646L29.0033 45.0077C29.0035 44.3125 29.6824 43.7491 30.5196 43.7493ZM62.8575 43.757C63.6947 43.7572 64.3731 44.321 64.3729 45.0162L64.3717 48.373C64.3715 49.0683 63.6926 49.6317 62.8555 49.6315C62.0183 49.6313 61.3398 49.0675 61.3401 48.3723L61.3412 45.0155C61.3415 44.3202 62.0203 43.7568 62.8575 43.757Z" fill="black" fill-opacity="0.6"/>
    <g opacity="0.5">
      <path d="M56.2861 38.3003C56.2864 37.605 55.6079 37.0413 54.7707 37.0411C53.9336 37.0409 53.2547 37.6043 53.2545 38.2995L53.2486 55.0837C53.2484 55.7789 53.9269 56.3427 54.764 56.3429C55.6012 56.3431 56.2801 55.7797 56.2803 55.0845L56.2861 38.3003Z" fill="black" fill-opacity="0.6"/>
      <path d="M40.1172 38.2964C40.1174 37.6012 39.439 37.0374 38.6018 37.0372C37.7646 37.037 37.0857 37.6005 37.0855 38.2957L37.0797 55.0799C37.0794 55.7751 37.7579 56.3388 38.5951 56.339C39.4323 56.3392 40.1111 55.7758 40.1114 55.0806L40.1172 38.2964Z" fill="black" fill-opacity="0.6"/>
    </g>
  </g>
  <defs>
    <filter id="filter0_d_815_7382" x="0" y="0" width="94" height="94" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feMorphology radius="3" operator="dilate" in="SourceAlpha" result="effect1_dropShadow_815_7382"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="7"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_815_7382"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_815_7382" result="shape"/>
    </filter>
  </defs>
</svg></div>
      <p style={{fontSize:'15px', fontFamily:'Manrope', fontWeight:700,color:'#FFF',marginTop:'40px'}}>Add Your Hopes & Goals for Maggie</p>
    </div>
    <div
      style={{
        marginTop: 0,
        display: "flex",
        flexDirection: "column",
        gap: 16,
      }}
    >
      <Field label="Your Biggest Hope for Your Student" placeholder="" />
      <Field label="How Mindy Can Support You" placeholder="" />
      <Field label="Concerns or Worries" placeholder="" />
      <Field label="What Helps You Feel Connected"  placeholder="" />
      {/* <Field label="Preferred Communication Style" placeholder="" /> */}
      <Field label="Parent Reflection" placeholder="" />

      

      {/* <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          minWidth: 0,
        }}
      >
        <label
          style={{
            color: "rgba(255,255,255,0.85)",
            fontFamily: "Manrope",
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Payment method
        </label>
        <div style={{ position: "relative", width: "311px" }}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            style={{
              width: "100%",
              height: 48,
              borderRadius: 16,
              padding: "0 16px",
              border: "1px solid rgba(255,255,255,0.22)",
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
              fontFamily: "Manrope",
              fontSize: 15,
              outline: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "all .2s ease",
            }}
          >
            <span>{paymentMethod}</span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              style={{
                transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform .2s ease",
              }}
            >
              <path
                d="M4 6L8 10L12 6"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {dropdownOpen && (
            <div
              style={{
                position: "absolute",
                top: "calc(100% + 8px)",
                left: 0,
                width: "100%",
                borderRadius: 16,
                border: "1px solid rgba(255,255,255,0.22)",
                background: "rgba(255,255,255,0.20)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                overflow: "hidden",
                zIndex: 10,
                boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
              }}
            >
              {paymentOptions.map((option) => (
                <button
                  key={option}
                  onClick={() => {
                    setPaymentMethod(option);
                    setDropdownOpen(false);
                  }}
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "none",
                    background:
                      paymentMethod === option
                        ? "rgba(255,255,255,0.15)"
                        : "transparent",
                    color: "#fff",
                    fontFamily: "Manrope",
                    fontSize: 15,
                    textAlign: "left",
                    cursor: "pointer",
                    transition: "background .2s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background =
                      "rgba(255,255,255,0.15)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background =
                      paymentMethod === option
                        ? "rgba(255,255,255,0.15)"
                        : "transparent")
                  }
                >
                  {option}
                </button>
              ))}
            </div>
          )}
        </div>
      </div> */}
    </div>
    </>
  );
}

const PinnedMindyFacts = ({ givenName }) => {
  const [facts, setFacts] = useState([
    {
      text: "Maggie loves surprise care packages with her favorite snacks",
      date: "Oct 6, 2025",
      pinned: false,
    },
    {
      text: "Maggie prefers phone calls over text messages.",
      date: "June 15, 2025",
      pinned: false,
    },
    {
      text: "Family dinner is every Sunday at 6 PM.",
      date: "May 9, 2025",
      pinned: false,
    },
    {
      text: "Maggie joined a sorority AEPHI",
      date: "March 22, 2025",
      pinned: false,
    },
  ]);

  const [newFact, setNewFact] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const addFact = () => {
    if (newFact.trim()) {
      const today = new Date().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
      setFacts([...facts, { text: newFact, date: today, pinned: false }]);
      setNewFact("");
    }
  };

  const deleteFact = (index) => {
    setFacts(facts.filter((_, i) => i !== index));
  };

  const togglePin = (index) => {
    const updatedFacts = [...facts];
    updatedFacts[index].pinned = !updatedFacts[index].pinned;
    setFacts(updatedFacts);
  };

  return (
    <div
      style={{
        maxWidth: "100%",
        minHeight: "100vh",
        padding: "24px",
        fontFamily: "Manrope, -apple-system, sans-serif",
      }}
    >
      {/* Header Card */}
      <div
        style={{
          display: "flex",
          width: "320px",
          padding: "16px",
          alignItems: "flex-start",
          gap: "8px",
          borderRadius: "16px",
          border: "1px solid var(--Grey-grey-100, #EBEBEB)",
          background: "rgba(255, 255, 255, 0.20)",
          marginTop: 40,
          gap: 16,
        }}
      >
        <div style={{}}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
          >
            <path
              d="M17.1287 27.525C17.1364 27.3419 17.4397 27.2692 17.5297 27.4289C17.9519 28.1784 18.6721 29.2806 19.4894 29.7818C20.3066 30.283 21.6156 30.4252 22.4751 30.4617C22.6582 30.4694 22.7309 30.7727 22.5712 30.8627C21.8217 31.2849 20.7195 32.0051 20.2183 32.8224C19.7171 33.6396 19.5749 34.9486 19.5384 35.8081C19.5306 35.9912 19.2274 36.0639 19.1374 35.9042C18.7152 35.1547 17.995 34.0525 17.1777 33.5513C16.3605 33.0501 15.0514 32.9079 14.192 32.8714C14.0089 32.8637 13.9362 32.5604 14.0959 32.4704C14.8454 32.0482 15.9476 31.328 16.4488 30.5107C16.95 29.6935 17.0922 28.3845 17.1287 27.525Z"
              fill="white"
            />
            <path
              opacity="0.5"
              d="M30.8185 25.8584C30.8044 25.6757 30.4846 25.5991 30.3892 25.7555C30.1021 26.2264 29.6879 26.7946 29.2276 27.0769C28.7674 27.3592 28.0731 27.4706 27.5232 27.5131C27.3405 27.5272 27.2639 27.847 27.4203 27.9424C27.8912 28.2295 28.4594 28.6437 28.7417 29.1039C29.024 29.5642 29.1354 30.2585 29.1779 30.8084C29.192 30.9911 29.5117 31.0677 29.6072 30.9113C29.8943 30.4404 30.3084 29.8722 30.7687 29.5899C31.229 29.3076 31.9233 29.1962 32.4732 29.1537C32.6559 29.1396 32.7325 28.8198 32.5761 28.7244C32.1052 28.4373 31.537 28.0231 31.2547 27.5628C30.9724 27.1026 30.861 26.4083 30.8185 25.8584Z"
              fill="white"
            />
            <path
              d="M24.5044 6.6696L24.1005 6.15948C22.5395 4.18769 21.7589 3.20179 20.8509 3.34733C19.9428 3.49287 19.5086 4.67346 18.6402 7.03464L18.4155 7.6455C18.1687 8.31647 18.0453 8.65196 17.8087 8.8982C17.5721 9.14443 17.2489 9.27354 16.6027 9.53177L16.0144 9.76686L15.6013 9.93214C13.6021 10.7342 12.5947 11.1888 12.4661 12.072C12.3289 13.0141 13.2824 13.82 15.1894 15.4318L15.6828 15.8488C16.2247 16.3069 16.4957 16.5359 16.651 16.848C16.8063 17.1602 16.8284 17.5202 16.8726 18.2401L16.9129 18.8955C17.0685 21.4289 17.1464 22.6956 17.9696 23.1323C18.7929 23.569 19.8164 22.8865 21.8634 21.5215L21.8634 21.5215L22.393 21.1683C22.9747 20.7804 23.2655 20.5865 23.5982 20.5332C23.9308 20.4799 24.2676 20.5732 24.9412 20.7599L25.5544 20.9299C27.9246 21.5869 29.1097 21.9155 29.7557 21.2433C30.4017 20.5711 30.0808 19.3433 29.4389 16.8879L29.2729 16.2526C29.0905 15.5549 28.9992 15.206 29.0495 14.8609C29.0998 14.5158 29.2858 14.2135 29.6578 13.609L29.6578 13.609L29.9966 13.0586C31.3058 10.9313 31.9605 9.86764 31.5364 9.01549C31.1124 8.16335 29.8906 8.08708 27.4469 7.93453L26.8146 7.89506C26.1202 7.85171 25.773 7.83003 25.4714 7.67006C25.1698 7.51009 24.948 7.22993 24.5044 6.66961L24.5044 6.6696Z"
              fill="white"
            />
            <path
              opacity="0.5"
              d="M14.7224 22.2105C11.1603 23.9508 8.19625 26.7071 7.07812 30.0007C5.82387 22.1548 7.56366 17.0882 10.3525 13.9392C10.5929 14.4304 10.9052 14.8371 11.1857 15.1549C11.7688 15.8156 12.606 16.5229 13.4561 17.241L14.0678 17.758C14.1838 17.856 14.274 17.9323 14.3507 17.9985C14.3585 18.1057 14.3662 18.2309 14.3762 18.3932L14.4259 19.2023C14.4927 20.294 14.5579 21.3596 14.7224 22.2105Z"
              fill="white"
            />
          </svg>
        </div>
        <div>
          <p style={{ color: "#FFF", fontSize: "18px", fontFamily: "Manrope" }}>
            Hello {givenName}, 
          </p>
          <p style={{ color: "#FFF", fontSize: "15px", fontFamily: "Manrope" }}>
            I'm learning from our chats. Click here for auto fill.
          </p>
        </div>
      </div>

      {/* Add New Fact Section */}
      <div style={{ marginBottom: "28px" }}>
        <h3
          style={{
            color: "#FFF",
            fontSize: "18px",
            fontWeight: 600,
            marginTop: "16px",
            marginBottom: "12px",
          }}
        >
          Add a New Item
        </h3>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            background: "rgba(255, 255, 255, 0.12)",
            borderRadius: "12px",
            padding: "4px",
            border: "1px solid rgba(255, 255, 255, 0.15)",
          }}
        >
          <style>
            {`
      input::placeholder {
        color: white;
        opacity: 0.8; /* optional: makes it a bit softer */
      }
    `}
          </style>
          <input
            type="text"
            value={newFact}
            onChange={(e) => setNewFact(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && addFact()}
            placeholder="Type something for Mindy to remember..."
            style={{
              flex: 1,
              background: "transparent",
              border: "none",
              color: "white",
              fontSize: "14px",
              padding: "12px 16px",
              outline: "none",
              fontFamily: "Manrope, sans-serif",
            }}
          />
          <button
            onClick={addFact}
            style={{
              background: "transparent",
              border: "none",
              color: "#FFF",
              fontSize: "14px",
              fontFamily: "Inter",
              fontWeight: 600,
              padding: "8px 16px",
              cursor: "pointer",
              whiteSpace: "nowrap",
            }}
          >
            + Add Item
          </button>
        </div>
      </div>

      {/* Pinned Facts Section */}
      <div>
        <h3
          style={{
            color: "#FFF",
            fontSize: "18px",
            fontWeight: 600,
            margin: "0 0 4px 0",
          }}
        >
          Pinned Items
        </h3>
        <p
          style={{
            color: "rgba(255, 255, 255, 0.75)",
            fontSize: "13px",
            margin: "0 0 16px 0",
          }}
        >
          These are things Mindy remembers about your family
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {facts.map((fact, index) => (
            <div
              key={index}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "16px",
                borderRadius: "12px",
                border: "1px solid rgba(255, 255, 255, 0.15)",
                transition: "all 0.2s ease",
                background:
                  hoveredIndex === index
                    ? "rgba(255, 255, 255, 0.12)" // hover color
                    : "transparent", // default color
                cursor: "pointer", // optional for better UX
              }}
            >
              {/* Icon */}
              <div
                style={{
                  width: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    opacity="0.5"
                    d="M4 9.67442C4 5.43595 7.35786 2 11.5 2C15.6421 2 19 5.43595 19 9.67442C19 11.9468 18.034 13.9892 16.5014 15.3934C15.9906 15.8614 15.6122 16.2082 15.344 16.4598C15.2099 16.5855 15.1074 16.6838 15.0317 16.7592C14.994 16.7968 14.9651 16.8266 14.9436 16.8496C14.933 16.861 14.925 16.8699 14.9192 16.8766L14.914 16.8826L14.9108 16.8864C14.6743 17.1851 14.6231 17.2622 14.5926 17.332C14.5621 17.4018 14.5402 17.4922 14.4805 17.8717C14.457 18.0216 14.4545 18.2782 14.4545 18.9767V19.0067C14.4546 19.4158 14.4546 19.7687 14.4289 20.0583C14.4018 20.3645 14.3418 20.6677 14.1805 20.9535C14.001 21.2717 13.7428 21.5359 13.4318 21.7196C13.1525 21.8846 12.8562 21.946 12.557 21.9738C12.274 22 11.9292 22 11.5294 22H11.5293H11.4707H11.4706C11.0708 22 10.726 22 10.443 21.9738C10.1438 21.946 9.84747 21.8846 9.56818 21.7196C9.25723 21.5359 8.99902 21.2717 8.81949 20.9535C8.65825 20.6677 8.5982 20.3645 8.57107 20.0583C8.54543 19.7687 8.54544 19.4158 8.54545 19.0067L8.54545 18.9767C8.54545 18.2782 8.54305 18.0216 8.51949 17.8717C8.45982 17.4922 8.43787 17.4018 8.40739 17.332C8.3769 17.2622 8.32571 17.1851 8.0892 16.8864L8.08591 16.8825L8.0808 16.8766C8.07499 16.8699 8.06699 16.861 8.05635 16.8496C8.03486 16.8266 8.00601 16.7968 7.9683 16.7592C7.89262 16.6838 7.7901 16.5855 7.65601 16.4598C7.38782 16.2082 7.0094 15.8614 6.49859 15.3934C4.96602 13.9892 4 11.9468 4 9.67442Z"
                    fill="white"
                  />
                  <path
                    d="M10.2978 13.6246C10.0904 13.266 9.63156 13.1435 9.27302 13.3509C8.91447 13.5583 8.79195 14.0171 8.99936 14.3757C9.35263 14.9864 9.93556 15.4498 10.631 15.6465V17.0001C10.631 17.4143 10.9668 17.7501 11.381 17.7501C11.7952 17.7501 12.131 17.4143 12.131 17.0001V15.6466C12.8264 15.4498 13.4094 14.9864 13.7626 14.3757C13.97 14.0171 13.8475 13.5583 13.489 13.3509C13.1304 13.1435 12.6716 13.266 12.4642 13.6246C12.247 14.0002 11.8427 14.2501 11.381 14.2501C10.9193 14.2501 10.515 14.0002 10.2978 13.6246Z"
                    fill="white"
                  />
                  <path
                    d="M9.91421 19.6745H13.0843C13.0814 19.7715 13.0769 19.8562 13.0701 19.9325C13.0516 20.1419 13.0203 20.2179 12.9988 20.2559C12.939 20.362 12.8529 20.4501 12.7493 20.5113C12.7121 20.5333 12.6378 20.5653 12.4331 20.5843C12.2191 20.6041 11.9366 20.6048 11.4993 20.6048C11.0619 20.6048 10.7795 20.6041 10.5654 20.5843C10.3607 20.5653 10.2864 20.5333 10.2493 20.5113C10.1456 20.4501 10.0595 20.362 9.99971 20.2559C9.97826 20.2179 9.94697 20.1419 9.92842 19.9325C9.92166 19.8562 9.91718 19.7715 9.91421 19.6745Z"
                    fill="white"
                  />
                </svg>
              </div>

              {/* Content */}
              <div style={{ flex: 1 }}>
                <p
                  style={{
                    color: "#FFF",
                    fontSize: "14px",
                    fontWeight: 500,
                    margin: "0 0 4px 0",

                    lineHeight: "1.4",
                  }}
                >
                  {fact.text}
                </p>
                <p
                  style={{
                    color: "rgba(255, 255, 255, 0.6)",
                    fontSize: "12px",
                    margin: 0,
                  }}
                >
                  Learned from chat on {fact.date}
                </p>
              </div>

              {/* Action Buttons */}
              {hoveredIndex === index && (
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    onClick={() => togglePin(index)}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: "4px",
                      display: "flex",

                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.9156 5.91996L14.0802 3.08455C13.1714 2.17579 12.4295 1.43379 11.7824 0.953513C11.1131 0.456736 10.3976 0.12678 9.57259 0.293382C8.74758 0.459984 8.21621 1.04173 7.79212 1.75931C7.38212 2.45305 6.98624 3.42483 6.50139 4.61499L5.53042 6.99827C5.23062 7.73416 5.14211 7.92203 5.01508 8.06011C4.96452 8.11506 4.90901 8.16524 4.84925 8.21001C4.69909 8.3225 4.50326 8.39165 3.74093 8.61586L3.69426 8.62959C2.89682 8.8641 2.2331 9.0593 1.73708 9.27226C1.23092 9.48958 0.746374 9.7863 0.482766 10.3158C0.341981 10.5987 0.263047 10.9082 0.251217 11.2239C0.229067 11.815 0.512359 12.3075 0.852651 12.7407C1.18613 13.1652 1.67532 13.6543 2.26312 14.2421L3.4459 15.4249L0.469814 18.4032C0.177026 18.6962 0.177026 19.1712 0.469814 19.4642C0.762602 19.7572 1.23731 19.7572 1.53009 19.4642L4.50656 16.4855L5.75803 17.737C6.34577 18.3248 6.83495 18.814 7.25942 19.1475C7.69258 19.4878 8.1851 19.771 8.77621 19.7489C9.0919 19.7371 9.40145 19.6581 9.68427 19.5173C10.2138 19.2537 10.5105 18.7692 10.7278 18.263C10.9408 17.767 11.136 17.1033 11.3705 16.3058L11.3842 16.2592C11.6085 15.4968 11.6776 15.301 11.7901 15.1509C11.8349 15.0911 11.885 15.0356 11.94 14.985C12.0781 14.858 12.2659 14.7695 13.0018 14.4697L15.3851 13.4987C16.5753 13.0139 17.547 12.618 18.2408 12.208C18.9584 11.7839 19.5401 11.2525 19.7067 10.4275C19.8733 9.60252 19.5434 8.88703 19.0466 8.21771C18.5663 7.57063 17.8243 6.82867 16.9156 5.91996ZM9.8695 1.7637C10.0782 1.72156 10.3528 1.76047 10.8884 2.158C11.4357 2.56423 12.0999 3.2256 13.0639 4.1896L15.8105 6.93622C16.7745 7.90022 17.4359 8.56437 17.8421 9.1117C18.2396 9.6473 18.2785 9.92191 18.2364 10.1306C18.1943 10.3393 18.0518 10.5773 17.4776 10.9167C16.8908 11.2634 16.0235 11.6189 14.761 12.1333L12.3332 13.1223C11.7501 13.3592 11.2872 13.5474 10.9244 13.8811C10.8017 13.9941 10.6896 14.1181 10.5896 14.2515C10.294 14.6461 10.1535 15.1256 9.97642 15.7295L9.9452 15.8359C9.69338 16.6921 9.52264 17.268 9.34952 17.6712C9.1766 18.074 9.06223 18.1514 9.0158 18.1745C8.92369 18.2204 8.82286 18.2461 8.72004 18.2499C8.66821 18.2519 8.53073 18.2387 8.18607 17.9679C7.841 17.6968 7.41533 17.273 6.78428 16.6419L3.35817 13.2158C2.72711 12.5848 2.30328 12.1591 2.03219 11.814C1.76142 11.4694 1.74822 11.3319 1.75016 11.2801C1.75402 11.1772 1.77973 11.0764 1.82558 10.9843C1.84869 10.9379 1.92612 10.8235 2.32886 10.6506C2.73209 10.4775 3.308 10.3067 4.16418 10.0549L4.27058 10.0237C4.87451 9.84665 5.35402 9.70609 5.74858 9.41052C5.88206 9.31052 6.00605 9.19844 6.11897 9.0757C6.45275 8.7129 6.64086 8.24999 6.87778 7.66694L7.86684 5.23909C8.3812 3.97656 8.73666 3.10929 9.08346 2.52249C9.42282 1.94828 9.66081 1.80585 9.8695 1.7637Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                  <button
                    onClick={() => deleteFact(index)}
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: "4px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                    >
                      <path
                        d="M3 6.52381C3 6.12932 3.32671 5.80952 3.72973 5.80952H8.51787C8.52437 4.9683 8.61554 3.81504 9.45037 3.01668C10.1074 2.38839 11.0081 2 12 2C12.9919 2 13.8926 2.38839 14.5496 3.01668C15.3844 3.81504 15.4756 4.9683 15.4821 5.80952H20.2703C20.6733 5.80952 21 6.12932 21 6.52381C21 6.9183 20.6733 7.2381 20.2703 7.2381H3.72973C3.32671 7.2381 3 6.9183 3 6.52381Z"
                        fill="white"
                      />
                      <path
                        opacity="0.5"
                        d="M11.5956 22.0001H12.4044C15.1871 22.0001 16.5785 22.0001 17.4831 21.1142C18.3878 20.2283 18.4803 18.7751 18.6654 15.8686L18.9321 11.6807C19.0326 10.1037 19.0828 9.31524 18.6289 8.81558C18.1751 8.31592 17.4087 8.31592 15.876 8.31592H8.12405C6.59127 8.31592 5.82488 8.31592 5.37105 8.81558C4.91722 9.31524 4.96744 10.1037 5.06788 11.6807L5.33459 15.8686C5.5197 18.7751 5.61225 20.2283 6.51689 21.1142C7.42153 22.0001 8.81289 22.0001 11.5956 22.0001Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.42543 11.4815C9.83759 11.4381 10.2051 11.7547 10.2463 12.1885L10.7463 17.4517C10.7875 17.8855 10.4868 18.2724 10.0747 18.3158C9.66253 18.3592 9.29499 18.0426 9.25378 17.6088L8.75378 12.3456C8.71256 11.9118 9.01327 11.5249 9.42543 11.4815Z"
                        fill="white"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14.5747 11.4815C14.9868 11.5249 15.2875 11.9118 15.2463 12.3456L14.7463 17.6088C14.7051 18.0426 14.3376 18.3592 13.9254 18.3158C13.5133 18.2724 13.2126 17.8855 13.2538 17.4517L13.7538 12.1885C13.795 11.7547 14.1625 11.4381 14.5747 11.4815Z"
                        fill="white"
                      />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}


function Mymindy() {
  const mindyOptions = [
    {
      name: "Priya D",
      image: "/mindyPRIYA.png"
    },
    {
      name: "Samantha B",
      image: "/mindySAMANTHA2.png"
    },
    {
      name: "Angie M",
      image: "/mindyANGIE.png"
    
    },
    {
      name: "Carrie B",
      image: "/mindyCARRIE.png"
    },
  ];

  const [selectedMindy, setSelectedMindy] = useState(mindyOptions[0]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const Mymindystyles = {
    card: {
      borderRadius: '8px',
      maxWidth: '384px',
      fontFamily: "Manrope",
      letterSpacing: "1px",
 
    },
    imageContainer: {
      display:'flex',
      fontFamily: "Manrope",
      marginBottom: '16px',
    },
    profileImage: {
      
      width: '192px',
      height: '192px',
      objectFit: 'cover',
      borderRadius: '4px'
    },
    editButton: {
     
      color: '#fff',
      fontFamily: "Manrope",
      fontSize: '14px',
      background: 'none',
      border: 'none',
      cursor: 'pointer',
      padding: '4px 8px'
    },
    nameSection: {
      marginBottom: '16px'
    },
    nameRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      marginBottom: '8px',
      fontFamily: "Manrope"
    },
    name: {
      color: 'white',
      fontSize: '24px',
      fontWeight: '600',
      fontFamily: "Manrope",
      margin: '0'
    },
    contactInfo: {
      color: 'white'
    },
    infoText: {
      fontSize: '14px',
      margin: '4px 0',
      color: 'white'
    }
  };
  return (
    <>
      <div
        style={{ color:'#FFF', gap: 16, marginTop: '40px', fontSize:'16px' }}
      >
        Preferred Mindy
      
        <img
          src={selectedMindy.image}
          alt="profile"
          style={{
            width: 192,
            height: 192,
            marginTop: 8,
            marginBottom: 4,
            // borderRadius: "50%",
            objectFit: "cover",
            objectPosition: "center",
            imageRendering: "auto",
            display: "block",
          }}
        />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <h3>{selectedMindy.name}</h3>
          <svg
            style={{
              marginLeft: 4,
            }} 
            xmlns="http://www.w3.org/2000/svg" 
            width="16" 
            height="16" 
            viewBox="0 0 16 16" 
            fill="none"
          >
            <g clipPath="url(#clip0_1947_14041)">
              <path d="M8.00065 11.833C8.27679 11.833 8.50065 11.6091 8.50065 11.333V7.33301C8.50065 7.05687 8.27679 6.83301 8.00065 6.83301C7.72451 6.83301 7.50065 7.05687 7.50065 7.33301V11.333C7.50065 11.6091 7.72451 11.833 8.00065 11.833Z" fill="white" fillOpacity="1.5"/>
              <path d="M8.00065 4.66634C8.36884 4.66634 8.66732 4.96482 8.66732 5.33301C8.66732 5.7012 8.36884 5.99967 8.00065 5.99967C7.63246 5.99967 7.33398 5.7012 7.33398 5.33301C7.33398 4.96482 7.63246 4.66634 8.00065 4.66634Z" fill="white" fillOpacity="1.5"/>
              <path fillRule="evenodd" clipRule="evenodd" d="M0.833984 7.99967C0.833984 4.04163 4.04261 0.833008 8.00065 0.833008C11.9587 0.833008 15.1673 4.04163 15.1673 7.99967C15.1673 11.9577 11.9587 15.1663 8.00065 15.1663C4.04261 15.1663 0.833984 11.9577 0.833984 7.99967ZM8.00065 1.83301C4.5949 1.83301 1.83398 4.59392 1.83398 7.99967C1.83398 11.4054 4.5949 14.1663 8.00065 14.1663C11.4064 14.1663 14.1673 11.4054 14.1673 7.99967C14.1673 4.59392 11.4064 1.83301 8.00065 1.83301Z" fill="white" fillOpacity="0.8"/>
            </g>
            <defs>
              <clipPath id="clip0_1947_14041">
                <rect width="16" height="16" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

        <div >
          <p style={Mymindystyles.infoText}>
            Name: <span style={{ textDecoration: "underline" }}>Priya D</span>
          </p>

          <p style={Mymindystyles.infoText}>Email: priya.d@mindyknows.com</p>
          <p style={Mymindystyles.infoText}>Phone: 310-376-4636</p>
          <p style={Mymindystyles.infoText}>Rating: ★★★★★ (4.9)</p>
          <button
            style={{
              height: "36px",
              borderRadius: "16px",
              padding: "0 16px",
              border: "1px solid rgba(255,255,255,0.8)",
              background: "transparent",
              color: "#fff",
              fontFamily: "Manrope",
              fontSize: "14px",
              fontWeight: "500",
              outline: "none",
              cursor: "pointer",
              transition: "all .2s ease",
              marginTop: "8px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(255,255,255,0.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "transparent";
            }}
            onClick={() => {
              // Add contact action here
              // console.log("Contact button clicked");
            }}
          >
            Contact
          </button>
        </div>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 8,
          minWidth: 0,
          // marginTop: 5,
        }}
      >
        <label
          style={{
            color: "#FFF",
            fontFamily: "Manrope",
            fontSize: 14,
            fontWeight: 500,
          }}
        >
          Mindys Available
        </label>
        <div style={{ position: "relative", width: "311px" }}>
          <button
            onClick={() => setDropdownOpen(!dropdownOpen)}
            style={{
              width: "100%",
              height: 48,
              borderRadius: 16,
              padding: "0 16px",
              border: "1px solid rgba(255,255,255,0.22)",
              background: "rgba(255,255,255,0.15)",
              color: "#fff",
              fontFamily: "Manrope",
              fontSize: 15,
              outline: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              transition: "all .2s ease",
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              {/* Image displayed in dropdown button */}
              <img
                src={selectedMindy.image}
                alt={selectedMindy.name}
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
              {selectedMindy.name}
            </span>
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              style={{
                transform: dropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform .2s ease",
              }}
            >
              <path
                d="M4 6L8 10L12 6"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          {dropdownOpen && (
            <div
              style={{
                position: "absolute",
                top: "calc(100% + 8px)",
                left: 0,
                width: "100%",
                borderRadius: 16,
                border: "1px solid rgba(255,255,255,0.22)",
                background: "rgba(255,255,255,0.20)",
                backdropFilter: "blur(20px)",
                WebkitBackdropFilter: "blur(20px)",
                overflow: "hidden",
                zIndex: 10,
                boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
              }}
            >
              {mindyOptions.map((option) => (
                <button
                  key={option.name}
                  onClick={() => {
                    setSelectedMindy(option);
                    setDropdownOpen(false);
                  }}
                  style={{
                    width: "100%",
                    padding: "12px 16px",
                    border: "none",
                    background:
                      selectedMindy.name === option.name
                        ? "rgba(255,255,255,0.15)"
                        : "transparent",
                    color: "#fff",
                    fontFamily: "Manrope",
                    fontSize: 15,
                    textAlign: "left",
                    cursor: "pointer",
                    transition: "background .2s ease",
                    display: 'flex',
                    alignItems: 'center',
                    gap: 12,
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.background =
                      "rgba(255,255,255,0.15)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.background =
                      selectedMindy.name === option.name
                        ? "rgba(255,255,255,0.15)"
                        : "transparent")
                  }
                >
                  {/* Image displayed in each dropdown option */}
                  <img
                    src={option.image}
                    alt={option.name}
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                  {option.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

     

    </>
  );
}
export default function MemoryPage() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [givenName, setGivenName] = useState("");

 // Fetch user attributes when component mounts
  useEffect(() => {
    const getUserAttributes = async () => {
      try {
        const attributes = await fetchUserAttributes();
        const name = attributes['custom:given_name'] || 
                    attributes.given_name || 
                    attributes.name || 
                    'Friend';
        setGivenName(name);
      } catch (error) {
        console.error('Error fetching user attributes:', error);
        setGivenName('Friend'); // Fallback name
      }
    };

    getUserAttributes();
  }, []);


  const tabs = [
    "My Mindy",
    "My Student",
    "Myself",
    "Friends & Family",
    "Hopes & Goals",
    "Mindy Knows",
  ];

  const renderContent = () => {
    switch (activeIdx) {
      case 0:
        return <Mymindy givenName={givenName} />;
      case 1:
        return <StudentProfile givenName={givenName} />;
      case 2:
        return <ParentProfile givenName={givenName} />;
      case 3:
        return <FriendsFamily givenName={givenName} />;
      case 4:
        return <HopesGoals givenName={givenName} />;
      case 5:
        return <PinnedMindyFacts givenName={givenName} />;
      default:
        return <ParentProfile givenName={givenName} />;
    }
  };

  return (
    <>
      <style>{`
      .memory-root {
       display: flex;
  flex-direction: column;
  
  max-width: 100vw; 
  height: min(${PANEL_H}px, calc(98vh - ${NAV_HEIGHT}px - 16px)); 
  margin: 0;  
  padding: 0;  
  box-sizing: border-box;  

        
      
}


.memory-panel {
  width: 100%;
  height: 96%;
  border-radius: ${PANEL_RADIUS}px;
  padding: clamp(16px, 2vw, 32px);
  background: rgba(255,255,255,0.15);
  border: 1px solid rgba(255,255,255,0.20);
  box-shadow: 0 8px 40px rgba(0,0,0,0.18);
  -webkit-backdrop-filter: blur(60px);
  backdrop-filter: blur(60px);
  display: grid;
  grid-template-columns: 0.4fr 1.2fr;
  column-gap: clamp(16px, 4vw, 64px);
  row-gap: 24px;
  max-width: 100%;
  box-sizing: border-box;
  font-family: Manrope, system-ui, sans-serif;
  overflow: hidden;
}

.menu-col {
  min-width: 311px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: auto;
  /* Remove: border-radius: 16px 0 0 16px; */
  padding-right: 16px;
}

.title {
  color: #fff;
  font-weight: 800;
  letter-spacing: -0.6px;
  margin: 0 0 12px 0;
  font-size: clamp(22px, 2.2vw, 28px);
  overflow: hidden;
  color: var(--Foundation-Foundation, #FFF);
  text-overflow: ellipsis;
  font-family: Manrope;
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  letter-spacing: -0.54px;
}

.tab-btn {
  height: 44px;
  width: 241px;
  padding: 0 16px;
  border-radius: 16px;
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  text-align: left;
  cursor: pointer;
  border: 1px solid transparent;
  background: transparent;
  transition: .2s;
  white-space: nowrap;
}

.tab-btn:hover {
  background: rgba(255,255,255,0.12);
}

.tab-btn.active {
  background: rgba(255,255,255,0.30);
}

.panel-scroll {
  overflow: auto;
  padding-right: 16px; /* Increased from 6px */
  min-height: 0;

}

.panel-scroll::-webkit-scrollbar {
  width: 10px;
}

.panel-scroll::-webkit-scrollbar-track {
  background: rgba(255,255,255,0.08);
  border-radius: 10px;
  backdrop-filter: blur(6px);
  margin: 8px 0; /* Added margin for better visual */
}

.panel-scroll::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, rgba(255,255,255,0.35), rgba(255,255,255,0.18));
  border: 2px solid rgba(255,255,255,0.12);
  border-radius: 10px;
}

.panel-scroll {
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.35) rgba(255,255,255,0.08);
}

.mk-input::placeholder {
  color: rgba(255,255,255,0.95);
  opacity: 1;
}

.mk-input:-ms-input-placeholder {
  color: rgba(255,255,255,0.95);
}

.mk-input::-ms-input-placeholder {
  color: rgba(255,255,255,0.95);
}

/* Media query for 1280px */
@media (max-width: 1280px) {
  .menu-col {
    border-radius: 16px; /* Keep this for mobile */
    padding: 16px;
    margin-bottom: 16px;
    min-width: auto;
    width: 100%;
  }
  
  .panel-scroll {
    border-radius: 16px; /* Keep this for mobile */
    padding: 16px;
    margin-top: 0;
  }
}

@media (max-width: 1014px) {
  .menu-col {
    border-radius: 16px; /* Keep this for mobile */
    padding: 12px 16px;
    margin-bottom: 16px;
  }
  
  .panel-scroll {
    border-radius: 16px; /* Keep this for mobile */
    padding: 16px;
  }
}

/* Media query for 768px */
@media (max-width: 768px) {
  .memory-root {
    right: 8px;
    width: calc(100vw - 16px);
    z-index: 100;
  }
  
  .memory-panel {
    padding: 12px;
  }
  
  .menu-col {
    padding: 8px 12px;
  }
  
  .panel-scroll {
    padding: 12px;
  }
  
  .tabs-row {
    gap: 6px;
  }
  
  .panel-scroll > div {
    gap: 12px;
  }
  
  .tab-btn {
    padding: 6px 10px;
    min-width: 100px;
    font-size: 16px;
  }
  
  .title {
    font-size: 20px;
  }
}


      `}</style>

      <div className="memory-root">
        <div className="memory-panel">
          <div className="menu-col">
            <div className="title">About Me</div>

            <div
              className="tabs-vertical"
              style={{ display: "flex", flexDirection: "column", gap: 12 }}
            >
              {tabs.map((t, i) => (
                <button
                  key={t}
                  onClick={() => setActiveIdx(i)}
                  className={`tab-btn ${i === activeIdx ? "active" : ""}`}
                >
                  {t}
                </button>
              ))}
            </div>

            <div className="tabs-row" style={{ display: "none" }}>
              {tabs.map((t, i) => (
                <button
                  key={`m-${t}`}
                  onClick={() => setActiveIdx(i)}
                  className={`tab-btn ${i === activeIdx ? "active" : ""}`}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>

          <div
            className="panel-scroll"
            style={{ display: "flex", flexDirection: "column", gap: 24 }}
          >
            {renderContent()}
          </div>
        </div>
      </div>
    </>
  );
}
